/**
 * MMT Promote: blocks - Popup
 *
 * Registering a shortcode block with Gutenberg.
 *
 * @author MoMo Themes
 */
/*jshint esversion: 6 */
//  Import CSS.
import './style.scss';
import './editor.scss';

const { __ } = wp.i18n; // Import __() from wp.i18n
const { registerBlockType } = wp.blocks; // Import registerBlockType() from wp.blocks



// Extend component
const { Component } = wp.element;
// Register editor components
const {
    InspectorControls,
} = wp.editor;
var el = wp.element.createElement;
// Register components
const {
    PanelBody,
    SelectControl,
    ToggleControl,
    TextControl,
} = wp.components;

registerBlockType( 'mmt-promote/promote-popup', {
    // Block name. Block names must be string that contains a namespace prefix. Example: my-plugin/my-custom-block.
    title: __( 'Promote Popup' ), // Block title.
    icon: {
        foreground: '#FF6978',
        src: 'shield'
    },
    category: 'mmt-promote-block', // Block category — Group blocks together based on common traits E.g. common, formatting, layout widgets, embed.
    keywords: [
        __( 'Promote' ),
        __( 'Event' ),
        __( 'promote-popup' ),
    ],
    attributes: {
        popupEventID: {
            type: 'string',
            default: '',
        },
        popupLoadTime: {
            type: 'string',
            default: 300,
        },
        popupOptin: {
            type: 'boolean',
            default: false
        },
        isPremium: {
            type: 'boolean',
            default: false
        }
    },
    supportHTML: true,

    //edit: PromotePopup,
    edit: function( props  ){
        var popupEventID = props.attributes.popupEventID;
        var popupLoadTime = props.attributes.popupLoadTime;
        var popupOptin = props.attributes.popupOptin;
        var setAttributes = props.setAttributes;

        var isPremium = mmt_promote_block_plans_fm.is_plan_premium;
        let premiumDataTxt;
        let premiumDataTgl;
        if (isPremium) {
            premiumDataTxt =
                <TextControl
                    label = {__('Load Time', 'mmt-promote')}
                    placeholder={ __( 'e.g 1000 ( in m.s )', 'mmt-promote' ) }
                    value={ popupLoadTime }
                    className='epa-popup-load-time'
                    onChange={ ( value ) => setAttributes( { popupLoadTime: value } ) } 
                />;
            premiumDataTgl =
                <ToggleControl
                    label={__('Enable Optin Form', 'mmt-promote')}
                    checked={popupOptin}
                    onChange= { (option) => setAttributes({popupOptin: option }) }
                />;
        }
        return [
            <div className={props.className} key={props.className}>
            <h4 id="mmt-propmote-popup-section-title">{__('Promote Popup', 'mmt-promote')}</h4>
            <p>{__('Please check right hand side Block Panel for settings.', 'mmt-promote')}</p>
                <InspectorControls>
                    <PanelBody title={ __( 'Popup Settings' ) } >
                        <TextControl 
                                label = {__('Event ID', 'mmt-promote')}
                                placeholder={ __( 'e.g 333', 'mmt-promote' ) }
                                value= {popupEventID}
                                className='epa-popup-event-id'
                                onChange={( value ) => setAttributes( { popupEventID: value } )}
                                //onChange = {onChangeEventID}
                        />
                        {premiumDataTxt}
                        {premiumDataTgl}
                    </PanelBody>
                </InspectorControls>
            </div>
        ];
    },
    
    save: function(props) {
        //TextControl.Content
        return null;
        
    },
} );
